import type { IImpressionWidget } from '@schibsted/pulse-sdk';
import type { ByfunnPulseContextInputParams } from '../../../types.js';

export interface WidgetViewAttributes {
  'data-track-event': string;
  'data-track-object-type': 'Widget';
}

export const buildImpressionWidgetAttributes = (
  event: ByfunnPulseContextInputParams<IImpressionWidget>,
): WidgetViewAttributes => ({
  'data-track-event': JSON.stringify(event),
  'data-track-object-type': 'Widget',
});
